var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSocialAuthTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#858994"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 12.5006C27.5318 13.0635 26.7366 13.494 25.895 13.7756C25.4433 13.1985 24.843 12.7895 24.1753 12.6038C23.5075 12.4182 22.8046 12.4649 22.1616 12.7376C21.5185 13.0103 20.9663 13.4959 20.5797 14.1287C20.1931 14.7614 19.9908 15.5108 20 16.2756V17.1089C18.682 17.1469 17.376 16.8221 16.1983 16.1634C15.0206 15.5048 14.0077 14.5328 13.25 13.3339C13.25 13.3339 10.25 20.8339 17 24.1672C15.4554 25.3322 13.6154 25.9163 11.75 25.8339C18.5 30.0006 26.75 25.8339 26.75 16.2506C26.7493 16.0184 26.7292 15.7869 26.69 15.5589C27.4555 14.7201 27.9956 13.6612 28.25 12.5006Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialAuthTwitter);
export default __webpack_public_path__ + "static/media/icon_social_auth_twitter.b62a7d7f78716fc498b3ac563af1040f.svg";
export { ForwardRef as ReactComponent };